import type { TFunction } from 'i18next'
import type { SafetyFunctionWithArchitecture } from '@/shared/hooks/api/machineryDirectiveCompliance'
import {
  defaultSafetyFunctionFormData,
  type SafetyFunctionFormData,
} from './safetyFunctionForm.schema'

export function toSafetyFunctionFormData(
  safetyFunction: SafetyFunctionWithArchitecture | null
): SafetyFunctionFormData {
  if (safetyFunction == null) {
    return defaultSafetyFunctionFormData
  }
  return {
    name: safetyFunction.name,
    description: safetyFunction.description ?? '',
    sfid: safetyFunction.sfid ?? '',
    sftype: safetyFunction.sftype ?? '',
    triggerevent: safetyFunction.triggerevent ?? '',
    reaction: safetyFunction.reaction ?? '',
    safestate: safetyFunction.safestate ?? '',
    responsetime: safetyFunction.responsetime ?? '',
    opmode: safetyFunction.opmode ?? '',
    sfinterfaces: safetyFunction.sfinterfaces ?? '',
    requestfrequency: safetyFunction.requestfrequency ?? '',
    priority: safetyFunction.priority ?? '',
    plcal: safetyFunction.plcal ?? '',
    plrdet: safetyFunction.plrdet ?? '',
  }
}

export function getSafetyFunctionSourceLabel(
  source: SafetyFunctionWithArchitecture['source'],
  translate: TFunction<'machineryDirectiveCompliance'>
): string {
  if (source === 'EPLAN') {
    return translate('safetyFunctionsPage.card.sourceEplan')
  }
  return translate('safetyFunctionsPage.sfDetail.sourceManual')
}

export function getOptionalFieldDisplayValue(
  value: string | null | undefined,
  naLabel: string
): string {
  if (value != null && value.trim().length > 0) {
    return value
  }
  return naLabel
}
